// extracted by mini-css-extract-plugin
module.exports = {"payTypeTitle":"native_select_pay_type_payTypeTitle__TDcMZ"};